import { ContentType, ContentItemType } from "app/types/ContentItem";

export const generateContentItem = (type:ContentType, id:number):ContentItemType => {
  return `urn:cc:${type}:${id}`;
};

export const parseContentItem = (contentItem:ContentItemType):[ContentType, number] => {
  const [ ,, type, id ] = contentItem.split(':');
  return [ type as ContentType, Number(id) ];
};